import { Mars, Venus, CircleHelp } from "lucide-react";
import { photoUrl } from "../lib/api";

export const SEX_ICON = { male: Mars, female: Venus, unknown: CircleHelp };
export const SEX_CLS = { male: "text-sky-600", female: "text-pink-500", unknown: "text-slate-400" };
export const BABY_STATUS_CLS = { available: "bg-emerald-100 text-emerald-700", reserved: "bg-amber-100 text-amber-800", home: "bg-slate-200 text-slate-600" };

export const BabyCard = ({ b, t, action }) => {
  const Sex = SEX_ICON[b.sex] || CircleHelp;
  return (
    <div className="rounded-xl border border-slate-200/80 bg-white overflow-hidden" data-testid={`baby-${b.id}`}>
      <div className="relative aspect-square bg-slate-100">
        {b.photo ? <img src={photoUrl(b.photo)} alt={b.name} className="h-full w-full object-cover" /> : <Sex size={30} className={`absolute inset-0 m-auto ${SEX_CLS[b.sex]}`} />}
        <span className={`absolute top-1.5 left-1.5 text-[10px] font-bold px-2 py-0.5 rounded-full ${BABY_STATUS_CLS[b.status]}`} data-testid={`baby-status-${b.id}`}>{t(`bb_${b.status}`)}</span>
        {action && <div className="absolute top-1.5 right-1.5">{action}</div>}
      </div>
      <div className="p-2">
        <p className="text-sm font-semibold text-[#12234A] flex items-center gap-1 truncate"><Sex size={13} className={SEX_CLS[b.sex]} /> {b.name || t(`bb_${b.sex}`)}</p>
        {b.color && <p className="text-[11px] text-slate-500 truncate">{b.color}</p>}
        {b.notes && <p className="text-[11px] text-slate-500 mt-0.5 line-clamp-2">{b.notes}</p>}
      </div>
    </div>
  );
};
